import { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Document, Page, pdfjs } from "react-pdf";
import { ReactComponent as OutlinedDownload } from "assets/icons/outlined-download.svg";
import { Button } from "antd";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useTranslation } from "react-i18next";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;
const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const PdfViewer = ({ fileName, pdf }) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(null);

  const onDocumentComplete = (e) => {
    setPages(e._pdfInfo?.numPages);
  };

  const saveFile = async () => {
    const url = URL.createObjectURL(pdf); //
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const onPage = (type) => {
    var newPage = type ? page + 1 : page - 1;

    if (newPage > pages) {
      newPage = 1;
    } else if (newPage < 1) {
      newPage = pages;
    }

    setPage(newPage);
  };

  const footer = (
    <div className="flex justify-between">
      <RightOutlined onClick={() => onPage(0)} />
      <span className="body-14px-medium">
        {t("page")} {page} {t("from")} {pages}
      </span>

      <LeftOutlined onClick={() => onPage(1)} />
    </div>
  );

  const title = (
    <Button
      className="absolute left-0 body-14px-medium flex items-center text-blue-0 z-10 hover:!text-blue-0 active:!text-blue-0"
      type="link"
      onClick={saveFile}
    >
      <OutlinedDownload className="ml-1 w-4 h-4 [&>path]:fill-blue-0" />
      {t("download")}
    </Button>
  );

  return (
    <div className="w-content body-14px-regular relative">
      {title}
      <Document
        className={"contract-pdf"}
        file={pdf}
        loading={t("loading")}
        options={options}
        onLoadSuccess={onDocumentComplete}
      >
        <Page pageNumber={page} />
      </Document>
      {footer}
    </div>
  );
};
export default PdfViewer;
